import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function completedMentorReducer(state = initialState.completedMentors, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_COMPLETED_MENTORS_SUCCESS:
            return action.completedMentors;
        default:
            return state;
    }
}
